<app-section-panel
  [sectionsContainer]="sectionsContainer"
  [sectionName]="'top'"
  [edit]="enableEditMode"
  [styleClass]="'user-form'"
></app-section-panel>
